<template>
        <div class="login background-blur h-screen" @click="showlogin = true" v-on:click="isHidden = false">

            <div class="boasvindas h-full"  v-if="!showlogin">

                <div class="flex mx-auto md:ml-auto ">
                    <img class="mr-5" src="@/assets/images/novaintegracao/avatar-novo.svg" alt="avatar"/>
                    <h3 class="my-auto text-white"><strong>Entrar</strong></h3>
                </div>

              <img class="responsive" src="@/assets/images/novaintegracao/integracao.svg" alt="" style="max-width:667px;">

                <img class="responsive" src="@/assets/images/novaintegracao/logo-wdc.svg" alt="" style="max-width:137px">

            </div>

            <transition name="logincard" >
                <div class="h-full flex flex-col justify-center aling-center items-center card-login"  v-if="showlogin" >

                    <div class="form">

                        <h1 class="text-white font-black text-3xl md:text-5xl">Área de acesso</h1>
                        <p class="text-white font-light text-base md:text-xl mt-3">Você está pronto para viver a <strong> experiência WDC? </strong> </p>

                        <form class="flex flex-col" action="" @submit.prevent="logar">

                            <div class="flex input-img">
                                <img  class="" src="@/assets/images/novaintegracao/email.svg" alt="" style="max-width:667px;" v-if="isHiddenemail">
                                <input class="mt-10" type="e-mail" placeholder=" Login" v-model="dados.email" v-on:blur="isHiddenemail = !isHiddenemail" v-on:focus="isHiddenemail = !isHiddenemail" required>
                            </div>

                            <div class="flex input-img">
                                <img class="" src="@/assets/images/novaintegracao/senha.svg" alt="" style="max-width:667px;"  v-if="isHiddensenha">
                                <input class="mt-10" type="password" placeholder="Senha" v-model="dados.password" v-on:blur="isHiddensenha = !isHiddensenha" v-on:focus="isHiddensenha = !isHiddensenha" required>
                            </div>

                            <button class="mt-10 enviar text-xl" type="submit"> ENVIAR </button>
                        </form>

                    </div>

                    <div class="flex flex-col justify-center aling-center items-center">

                        <img class="flex-grow my-auto pt-20" src="@/assets/images/novaintegracao/logo-nova.svg" alt="">
                    </div>

                </div>
            </transition>

        </div>

</template>

<script>

  import moduleIntegracao from "../../store/integracao/moduleIntegracao";


    export default {
        name: "Login",
        data() {
            return {
                active1: true,
                showlogin:false,
                isHidden: true,
                isHiddenemail: true,
                isHiddensenha:true,
                active2: false,
              dados:{
                email: '',
                password: '',
              },
                toastCount: 0
            }
        },
        created() {
            this.$store.dispatch('integracao/setStep', 0);
        },
        methods: {
            seguir() {
                if (this.email != '') {
                    this.active1 = false;
                    this.active2 = true;
                } else {
                    this.$vs.notify({
                        color: 'danger',
                        title: 'E-mail inválido',
                        text: 'Digite um e-mail válido'
                    })
                }
            },

          logar() {

            this.$store.dispatch("integracao/login",{
              identifier: this.dados.email,
              password:this.dados.password
            }).then((response) => {
              this.user = response.data.user;
              this.$router.push({name:'inicio-integracao'})
            }).catch(()=>{
              this.$vs.notify({
                color: 'danger',
                title: 'Usuário ou senha incorreto',
                text: 'Verifique se os dados foram digitados corretamente'
              })
            });
          }
        }
    }
</script>

<style>
    *{
        border: none;
    }
  .login{
    background-image: url('../../assets/images/novaintegracao/bg-login.png');
    background-position: center;
    background-size: cover;

}
.boasvindas{
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: space-between;
    padding: 3%;
}
.form{
    max-width: 506px;
    max-height: 409px;
}
.form img{
    width: 30px;
    position: relative;
    margin-top: 18px;
    transition: 200ms;
    max-width: 667px;
}

.enviar{
    letter-spacing: 7px;
    background-color: #C61517;
    border: #C61517 3px solid;
    color:#fff;
    height: 65px !important;
    cursor: pointer;
}
form input{
    color:#fff ;
    height: 47px;
    background-color: transparent;
    width: 100% ;
    font-size: 22px;
    padding-left: 20px;
}
.input-img{
    border-bottom: 1px solid #CBCBCB;

}
::placeholder{
    color:#fff ;
    font-size: 22px;
    margin-left: 20px;
}

.form h1{
    border-left: 10px solid #C61517;
    padding-left: 10px;
}


.logincard-enter-active {
  transition: all .3s ease;
}
.logincard-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.logincard-enter, .logincard-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}

.card-login{
    -webkit-backdrop-filter: blur(5px); /* Use for Safari 9+, Edge 17+ (not a mistake) and iOS Safari 9.2+ */
    backdrop-filter: blur(5px); /* Supported in Chrome 76 */
}

@media (max-width: 500px){
    .form{
        max-width: 300px;
    }
    .form img{
        width: 20px;
    }
.enviar{
    font-size: 15px !important;
    height: 40px !important;
}

.boasvindas img{
    max-height: 100px;
}

}

</style>
